// Fits the compact TrackingBadge, so labels with or without it share one height
const LABEL_ROW_MIN_HEIGHT = '16px';

export const getStyles = (theme) => ({
  container: {
    height: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  },
  labelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    minHeight: LABEL_ROW_MIN_HEIGHT,
  },
  labelRowSpaced: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    minHeight: LABEL_ROW_MIN_HEIGHT,
    marginBottom: '4px',
  },
  label: {
    fontFamily: 'AvenirNext-DemiBold',
    fontSize: '10px',
    fontWeight: '600',
    color: theme.palette.color.grayMain,
    marginBottom: '3px',
  },
  title: {
    fontFamily: 'AvenirNext-DemiBold',
    fontSize: '16px',
    fontWeight: '600',
    color: theme.palette.color.blackMain,
  },
  text: {
    fontFamily: 'AvenirNext',
    fontSize: '10px',
    color: theme.palette.color.black,
  },
  highlightCode: {
    backgroundColor: `${theme.palette.primary.main}80`,
    display: 'inline-block',
    padding: '4px 8px',
    margin: '2px 4px',
    borderRadius: '3px',
    color: theme.palette.color['greyish-brown'],
    fontSize: '12px',
    verticalAlign: 'middle',
  },
  statusBox: {
    fontFamily: 'AvenirNext-Italic',
    fontSize: '11px',
    color: theme.palette.color.gray,
    fontStyle: 'italic',
    fontWeight: '300',
  },
  status: {
    fontWeight: '400',
    fontSize: '12px',
  },
  driverSection: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  driverScrollArea: {
    flex: 1,
    minHeight: 0,
    overflowY: 'scroll',
  },
  dialogPaper: {
    padding: '24px',
  },
  dialogTitle: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '20px',
  },
  dialogContent: {
    margin: '8px 0px',
    color: theme.palette.color.grayMain,
  },
  dialogButton: {
    padding: '4px 48px',
  },
  footerScroll: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    overflowX: 'scroll',
    overflowY: 'hidden',
  },
});
